import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { productBannerAction } from '@redux/action';

export const useProductPageBanner = () => {
    const dispatch = useDispatch();
    const productBannerByProductPage = useSelector((state) => state.productBannerReducer?.productBannerByProductPage || null);
    const languageRedux = useSelector((state) => state.language);
    const screenRedux = useSelector((state) => state.screen);

    useEffect(() => {
        const fetchData = async () => {
            const countryLanguageKey = languageRedux?.countryLanguageKey.replace('_', '-').toLowerCase() || '';
            const viewType = screenRedux?.viewType || '';

            try {
                const productBannerSettings = await window.SPL_Content.getProductBannerSettings();
                const bannerData = productBannerSettings?.[countryLanguageKey]?.[viewType] || null;
                dispatch(productBannerAction.setProductBannerData(bannerData)); // Save data to Redux
            } catch (error) {
                console.error('Error fetching product banner settings:', error);
            }
        };

        if (!productBannerByProductPage) {
            fetchData(); // Fetch only if data is not in Redux
        }
    }, [languageRedux, screenRedux, productBannerByProductPage, dispatch]);

    return { productBannerByProductPage };
};
